import type { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';

import type {
  CompletedCalculationTactic,
  LoadFlowMergedScenariosResult,
  LoadFlowScenarioInputs
} from '../../../..';
import type { ForStoringAttentionStatus } from '../../../../evaluation/AttentionStatusRepository';
import { EnergyConsumerEvaluation } from '../../../../evaluation/loadFlow/gridElements/energyConsumer/energyConsumerEvaluation';
import type { ForEnergyConsumerEvaluation } from '../../../../evaluation/loadFlow/gridElements/energyConsumer/forEnergyConsumerEvaluation';
import {
  findGridElementLabel,
  findGridElementTitle
} from '../../findGridElementLabel';
import { findLoad } from '../findLoad';
import type { EnergyConsumerLoadFlowDetails } from '../gridElementLoadFlowDetails.types';
import { Features } from '../../../../createGridElementCalculationSetExecutionDetails';

export function createEnergyConsumersLoadFlowDetails(
  features: Features,
  evaluationEngine: ForEnergyConsumerEvaluation,
  results: LoadFlowMergedScenariosResult[],
  calculationTactic: CompletedCalculationTactic,
  attentionStatusRepository: ForStoringAttentionStatus,
  inputs: LoadFlowScenarioInputs
): EnergyConsumerLoadFlowDetails[] {
  const evaluatedResults = EnergyConsumerEvaluation.fromResults(
    results,
    attentionStatusRepository
  ).evaluateEachConsumer(evaluationEngine);

  return evaluatedResults.map(evaluatedConsumer => ({
    ...evaluatedConsumer,
    label: findGridElementLabel(features, evaluatedConsumer.id),
    title: findGridElementTitle(features, evaluatedConsumer.id),
    inputs: findLoad(evaluatedConsumer.id, calculationTactic, inputs)
  }));
}
